const faqs = [
  {
    q: '蘑菇影院的视频画质怎么样？',
    a: '蘑菇影院提供1080P超高清画质播放，所有影视资源均经过精心筛选和优化，确保您在观看高清电影在线和高清电视剧全集时获得清晰细腻的视觉体验。',
  },
  {
    q: '观看需要注册或付费吗？',
    a: '完全不需要！蘑菇影院是一个完全免费的在线高清影视平台，无需注册、无需付费，打开网站即可畅享海量高清资源，真正实现自由观影。',
  },
  {
    q: '为什么有时候播放会卡顿？',
    a: '蘑菇影院采用先进的视频加速技术，正常情况下播放流畅不卡顿。如遇卡顿，建议检查您的网络连接，或尝试切换到其他播放线路，通常能解决问题。',
  },
  {
    q: '资源多久更新一次？',
    a: '蘑菇影院片库每日更新，最新高清电影、热播电视剧全集会在第一时间上线。您可以关注更新动态板块，了解最新的资源上线信息。',
  },
  {
    q: '手机上可以观看吗？',
    a: '当然可以！蘑菇影院完美适配手机和平板等移动设备，无需下载APP，直接用浏览器访问即可享受高清流畅的观影体验，随时随地追剧不卡顿。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              关于蘑菇影院的常见疑问，这里都有解答
            </p>
          </div>

          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => (
              <details key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-sm md:text-base font-semibold text-foreground-900 hover:text-accent-600 transition-colors list-none">
                  <span className="pr-4">{faq.q}</span>
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-accent-100 flex-shrink-0 transition-colors">
                    <i className="ri-arrow-down-s-line text-sm text-foreground-500 group-open:text-accent-600 transition-transform group-open:rotate-180"></i>
                  </div>
                </summary>
                <div className="px-5 md:px-6 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}